/**
 * Client for /api/onboarding (admin) and /api/public/onboarding (public).
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const unwrap = (p) => p.then(r => r.data).catch(err => {
  const msg = err?.response?.data?.detail || err.message;
  throw new Error(msg);
});

export const OnboardingPublicAPI = {
  locations: () => unwrap(axios.get(`${API}/public/onboarding/locations`)),
  submit: (payload) => unwrap(axios.post(`${API}/public/onboarding/submit`, payload)),
  encryptSSN: (ssn) => unwrap(axios.post(`${API}/public/onboarding/encrypt-ssn`, { ssn })),
  uploadFile: (file, idType, onProgress) => {
    const fd = new FormData();
    fd.append('file', file);
    return unwrap(axios.post(
      `${API}/public/onboarding/upload${idType ? `?id_type=${idType}` : ''}`,
      fd,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
          if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
        },
      },
    ));
  },
};

export const OnboardingAdminAPI = {
  list: (status) => unwrap(axios.get(`${API}/onboarding/submissions`,
    { params: status ? { status } : {}, withCredentials: true })),
  get: (id) => unwrap(axios.get(`${API}/onboarding/submissions/${id}`, { withCredentials: true })),
  update: (id, body) => unwrap(axios.put(`${API}/onboarding/submissions/${id}`, body, { withCredentials: true })),
  remove: (id) => unwrap(axios.delete(`${API}/onboarding/submissions/${id}`, { withCredentials: true })),
  stats: () => unwrap(axios.get(`${API}/onboarding/stats`, { withCredentials: true })),
  fileMeta: (fileId) => unwrap(axios.get(`${API}/onboarding/files/${fileId}/meta`, { withCredentials: true })),
  fileDownloadUrl: (fileId, inline = false) =>
    `${API}/onboarding/files/${fileId}${inline ? '?inline=true' : ''}`,
  fileThumbUrl: (fileId) =>
    `${API}/onboarding/files/${fileId}/thumb`,
  warmupFiles: (fileIds) => unwrap(axios.post(
    `${API}/onboarding/files/warmup`,
    { file_ids: fileIds },
    { withCredentials: true },
  )),
  revealSSN: (id) => unwrap(axios.post(`${API}/onboarding/submissions/${id}/reveal-ssn`, {}, { withCredentials: true })),
};
